// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rsk-arrow,
.rsk-dash {
  position: relative;
  font-size: 6px;
  margin-right: 30px;
  margin-left: 5px;
}

.rsk-arrow:before,
.rsk-dash:before {
  position: absolute;
  top: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/rsk-font/styles.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".rsk-arrow,\n.rsk-dash {\n  position: relative;\n  font-size: 6px;\n  margin-right: 30px;\n  margin-left: 5px;\n}\n\n.rsk-arrow:before,\n.rsk-dash:before {\n  position: absolute;\n  top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
